export const zhTW = {
  language: "中文",
  nav: {
    home: "首頁",
    products: "產品服務",
    about: "關於我們",
    contact: "聯絡我們",
    news: "新聞中心",
    resources: "文件資源",
    quickStart: "文件中心",
    documentation: "文件",
    apiReference: "API 參考",
    tutorials: "教學",
    learnMore: "了解更多",
    rma: "RMA 申請",
    login: "登入",
    search: "搜尋",
  },
  home: {
    companyIntro: {
      learnMore: "了解更多",
    },
  },
  hero: {
    slide1: {
      title: "Sailflow AI Platform",
      subtitle: "領先的 GPU 雲端運算平台",
      description:
        "為 AI 開發者和企業提供靈活、高效的 AI 運算資源，加速您的 AI 創新之旅",
      cta: "立即體驗",
    },
    slide2: {
      title: "AI 伺服器與工作站",
      subtitle: "專業級運算解決方案",
      description:
        "提供高效能 AI 伺服器和工作站，滿足深度學習、科學運算等多元需求",
      cta: "了解更多",
    },
    slide3: {
      title: "AI 資料中心管理軟體",
      subtitle: "智慧化資源與應用服務管理",
      description: "輕鬆監控叢集資源、提升工作效率，打造您的專屬雲端運算平台",
      cta: "探索功能",
    },
  },
  about: {
    title: "關於我們",
    subtitle:
      "我們是台灣領先的 AI 算力服務提供商，致力於為 AI 開發者和企業提供最優質的運算資源和解決方案",
    heading: "引領 AI 算力",
    headingSub: "創新未來",
    desc1:
      "透過專業的叢集管理技術與 Sailflow AI Infra™ 管理平台，我們讓 AI 算力的使用變得更加簡單、靈活與經濟。",
    desc2:
      "從 AI 伺服器硬體到資料中心叢集管理軟體，我們提供端到端的完整解決方案，幫助使用者加速 AI 模型訓練、推理部署，以及各類高效能運算任務。我們的使命是讓所有組織都能輕鬆獲得世界級的 AI 運算能力。",
    stats: {
      experience: "年行業經驗",
      clients: "企業客戶",
      nodes: "AI 運算節點",
      availability: "服務可用性",
    },
  },
  products: {
    title: "核心產品",
    subtitle: "提供全方位的 AI 運算解決方案，滿足不同場景的需求",
    learnMore: "了解更多",
    product1: {
      title: "Sailflow AI Platform",
      subtitle: "GPU 雲端運算平台",
      description:
        "靈活的按需付費模式，支援多種 GPU 型號選擇，一鍵部署 AI 開發環境，提供完整的監控和管理工具。",
      feature1: "彈性擴展",
      feature2: "按需計費",
      feature3: "快速部署",
      feature4: "輕鬆管理",
    },
    product2: {
      title: "AI 伺服器與工作站",
      subtitle: "專業硬體解決方案",
      description:
        "配備最新 NVIDIA GPU 的高效能伺服器和工作站，支援深度學習、科學運算、渲染等多種應用場景。",
      feature1: "高效能",
      feature2: "可客製化",
      feature3: "企業級",
      feature4: "專業支援",
    },
    product3: {
      title: "AI 資料中心管理軟體",
      subtitle: "智慧化資源與應用服務管理",
      description:
        "強大的叢集管理平台，提供資源調度、任務排程、應用管理、效能監控、故障預警等全方面管理功能。",
      feature1: "智能調度",
      feature2: "可視化",
      feature3: "自動化",
      feature4: "高可用",
    },
  },
  news: {
    title: "最新動態",
    sidebarTitle: "新聞中心",
    subtitle: "了解我們的最新產品發布、技術分享和行業洞察",
    readMore: "閱讀更多",
    viewAll: "查看所有動態",
    category: {
      product: "產品發布",
      tech: "技術分享",
      industry: "行業動態",
    },
    article1: {
      title: "Sailflow AI Platform 10.0 正式發布",
      excerpt:
        "全新版本帶來更強大的功能和更優化的用戶體驗，支援更多 GPU 型號和更靈活的計費方式...",
      date: "2025年1月15日",
    },
    article2: {
      title: "如何選擇適合的 GPU 進行深度學習訓練",
      excerpt:
        "深入解析不同 GPU 型號的效能特點，幫助您根據實際需求選擇最合適的運算資源...",
      date: "2025年1月10日",
    },
    article3: {
      title: "AI 算力需求持續增長， GPU 租借市場前景廣闊",
      excerpt:
        "隨著大型語言模型和生成式 AI 的興起，企業對 AI 算力的需求呈現爆發式增長...",
      date: "2025年1月5日",
    },
    tag: {
      hot: "熱門",
      collaboration: "合作",
      tech: "技術",
    },
    cyintell: "承羽智慧",
    aiInfra: "AI 基礎設施",
    backToHome: "返回首頁",
    contentNotFound: "# 內容載入失敗\n\n無法載入所請求的內容。",
  },
  cases: {
    title: "客戶案例",
    subtitle: "看看我們如何幫助各行業客戶實現 AI 創新",
    viewCase: "查看案例",
    challenge: "專案目標",
    solution: "解決方案",
    case1: {
      company: "政府機構資訊部門",
      industry: "AI 基礎設施",
      title: "打造自主 AI 運算設施，支援跨單位創新應用研發",
      solutionText: "協助建置運算、存儲及網管設備，導入 Sailflow AI Platform 整合叢集資源，打造自主可控的 AI 雲端服務系統，支援跨單位資源調度與創新 AI 應用研發。",
      description: "節省 90% 叢集資源與應用環境維運管理時間，加速實現跨單位創新研發目標。",
    },
    case2: {
      company: "科研院所資訊部門",
      industry: "科研機構",
      title: "支援中短期 AI 研發服務專案，縮短研發週期與節省成本",
      solutionText: "提供內建 Sailflow AI Platform 的伺服器租賃服務，快速取得強大運算力與研發輔助系統，加速研發、兼顧資安，並節省建置與一般雲端服務的昂貴成本。",
      description: "節省超過 60% 的系統建置或雲端服務成本，享受充裕的時間與資源進行完整的應用研發、交付專案。",
    },
    case3: {
      company: "大專院校資訊工程學系",
      industry: "教育研究",
      title: "支援百人課程教學使用",
      solutionText: "提供內建 Sailflow AI Platform的雲端伺服器租賃服務。過去在相同預算下，僅能建置有限的 GPU ，透過雲端 GPU 服務可實現隨需即用，同時百人上限使用多張 GPU。並透過研發及管理輔助系統，提升教學效果、減輕課程資源管理負擔。",
      description: "節省超過 70% 的系統建置或雲端服務成本，實現百人同時運算使用、輕鬆管理課程資源。",
    },
    case4: {
      company: "製造業領域 AI 軟體系統服務商",
      industry: "製造業",
      title: "基於多運算設備叢集的製造業瑕疵檢測模型開發工具軟體",
      solutionText: "基於 Sailflow AI Platform，整合製造業瑕疵檢測模型開發工具，包括資料標註、模型訓練、電腦視覺、資料分析等多種功能，實現多運算設備叢集調度，高效運用資源、縮短工作時間。",
      description: "軟體服務商可專注於關鍵應用研發，提升軟硬整合的服務能力，實現資料中心叢集規模的服務運行。",
    },
    case5: {
      company: "健康醫療領域 AI 軟體系統服務商",
      industry: "健康醫療",
      title: "打造符合國際規範的健康醫療 AI 模型市集",
      solutionText: "基於 Sailflow AI Platform 的叢集資源管理系統以及應用服務管理系統，可向上架構 AI 健康醫療模型市集，支持實現雲地合規資料交換與 Healthcare AI SaaS 商業模式。",
      description: "軟體服務商可專注於關鍵健康醫療應用研發，提升軟硬整合服務能力，加速雲地服務拓展。",
    },
    case6: {
      company: "金融業領域 AI 軟體系統服務商",
      industry: "金融業",
      title: "打造符合資訊安全規範的雲地金融業生產力 AI 應用",
      solutionText: "基於 Sailflow AI Platform 與專業硬體解決方案，協助串接雲地資源調度，以符合金融業在資安合規下的生產力 AI 應用，提升數位化、AI 化的服務能力。",
      description: "軟體服務商可專注於關鍵生產力應用研發，提升軟硬整合服務能力，加速資安合規的雲地服務拓展。",
    },
  },
  coverage: {
    title: "業務覆蓋",
    subtitle: "我們的服務遍布全球主要城市和地區",
    regions: {
      singapore: "新加坡",
      japan: "日本",
      usa: "美國",
      germany: "德國",
      uk: "英國",
      thailand: "泰國",
      taiwan: "台灣",
    },
    clients: "客戶",
    DCs: "數據中心",
    serviceRegionsClientDistribution: "服務地區與客戶分佈",
    dataCenters: "數據中心",
    serviceCountries: "服務國家",
    enterpriseClients: "企業客戶",
    gpuNodes: "GPU 節點",
    global: {
      serviceStatistics: "全球服務統計",
      service: "覆蓋全球主要地區",
      serviceContent:
        "我們在美國、日本、泰國、新加坡、台灣、英國、德國等主要國家和地區建立了現代化的數據中心，配備最先進的 GPU 運算設備。無論您的企業位於何處，都能享受到快速、穩定的 GPU 算力服務。",
      serviceFeature: [
        "低延遲網絡連接，確保最佳效能",
        "99.9% 服務可用性保證",
        "24/7 技術支援團隊",
        "符合國際安全標準的數據中心",
      ],
    },
  },
  testimonials: {
    title: "客戶評價",
    subtitle: "聽聽客戶對我們服務的真實反饋",
    testimonial1: {
      content:
        "作為一家專注於 LLM 模型預訓練和微調的 AI 公司，我們最看重的不是單純的 GPU 數量，而是算力的持續穩定性與網路傳輸的效率。在與承羽智慧合作之前，環境配置與算力調度往往佔據了研發團隊 30% 以上的時間。自從導入了承羽智慧的 算力平台後，我們的研發效能有了顯著提升。承羽平台快速的環境部署，優異的算力彈性，以及極致的在地服務，都令我們的研發人員印象深刻，並成功的地提升我們的開發效率。",
      author: "",
      position: "執行長",
      company: "APMIC",
    },
    testimonial2: {
      content:
        "身為使用者，我真心推薦承羽智慧的GPU運算軟硬體。系統穩定、部署順暢，遇到技術問題時，客服與工程師回覆超快、處理也確實到位。無論是AI訓練或日常運算，都能放心交給他們，讓我們的專案進行得更有效率、更沒有後顧之憂。",
      author: "",
      position: "執行長",
      company: "數位設計應用科技公司",
    },
    testimonial3: {
      content:
        "感謝承羽智慧在GPU底層硬體控制上面讓我們省了很多麻煩，系統穩定部署過程也非常順場，如果遇到相關問題也有對應窗口服務，在現在打群架的時代中，我們的產品跟專案都非常需要這些AI Infra的幫助，讓我們的影像辨識與數據分析、LLM產品再跟客戶合作上無往不利。",
      author: "",
      position: "策略長",
      company: "製造業AI解決方案科技公司",
    },
    testimonial4: {
      content:
        "國人自行開發的管理軟體，中文化介面，操作很直覺，很容易上手，我們是購買軟體並建置於自有的AI伺服器，使用1年很方便，沒有太大的問題，收費又不貴，很推薦大家使用。",
      author: "",
      position: "資深分析師",
      company: "衛生福利部",
    },
  },
  faq: {
    title: "常見問題",
    subtitle: "解答您關心的問題",
    moreQuestions: "還有其他問題",
    contactUs: "聯絡我們",
    q1: {
      question: "Sailflow AI Platform 支援哪些 GPU 型號？",
      answer:
        "我們支援NVIDIA全系列GPU、AMD NAVI4以上系列GPU、Phison aiDAPTIV+ SSD，以及x86及ARM CPU。",
    },
    q2: {
      question: "如何計費？有哪些付費方式？",
      answer:
        "雲端服務方面，我們提供靈活的按需計費模式，按資源量與使用時長計費，支援小時計費以及包月套餐。支援信用卡、銀行轉帳等多種付款模式；地端部署版本則依照部署的GPU數量，以年訂閱模式計費，並收取到府的部署安裝服務費用。",
    },
    q3: {
      question: "提供哪些技術支援服務？",
      answer:
        "我們提供營業時間技術支援，包括系統部署、故障排除等。企業客戶還可享受專屬技術顧問服務。",
    },
    q4: {
      question: "是否支援試用？",
      answer:
        "是的，我們為新用戶提供免費試用額度，讓您可以先體驗平台功能和性能，滿意後再正式使用。",
    },
  },
  contact: {
    title: "聯絡我們",
    subtitle: "有任何問題或需求？歡迎隨時與我們聯繫",
    phone: "電話",
    email: "電子郵件",
    address: "地址",
    addressDetail: "臺北市大安區敦化南路 2 段 77 號 7 樓之 4",
    contactInfo: "聯絡資訊",
    businessHours: "營業時間",
    businessHoursDetail: "週一至週五 9:00-18:00",
    followUs: "關注我們",
    sendMessage: "發送訊息",
    interestedProduct: "感興趣的產品",
    selectProduct: "請選擇",
    maxCharacters: "最多 500 字",
    messagePlaceholder: "請描述您的需求或問題...",
    namePlaceholder: "請輸入您的姓名",
    companyPlaceholder: "請輸入公司名稱",
    form: {
      name: "姓名",
      email: "電子郵件",
      phone: "電話",
      company: "公司名稱",
      message: "留言內容",
      submit: "提交",
      other: "其他",
    },
  },
  newsletter: {
    title: "訂閱我們的電子報",
    subtitle: "獲取最新的產品資訊、技術文章和行業動態",
    placeholder: "請輸入您的電子郵件",
    button: "訂閱",
    privacy: "我們尊重您的隱私，不會向第三方分享您的資訊",
    subscribing: "訂閱中...",
    subscribeSuccess: "訂閱成功！感謝您的關注。",
    subscribeError: "訂閱失敗，請稍後再試。",
  },
  footer: {
    description: "專業的 AI 算力解決方案提供商，為 AI 創新賦能",
    quickLinks: "快速連結",
    products: "產品服務",
    solutions: "解決方案",
    resources: "資源中心",
    support: "支援服務",
    contact: "聯絡我們",
    links: {
      platform: "Sailflow AI Platform",
      servers: "AI 伺服器與工作站",
      software: "AI 叢集管理軟體",
      aiTraining: "AI 模型訓練",
      deepLearning: "深度學習",
      scientificComputing: "科學運算",
      news: "最新動態",
      docs: "技術文檔",
      blog: "技術部落格",
      cases: "客戶案例",
      faq: "常見問題",
      support: "技術支援",
      training: "培訓服務",
      terms: "使用條款",
      privacy: "隱私政策",
    },
    copyright: "© 2026 C.Y. Intelligence Co., Ltd. 版權所有。",
    poweredBy: "網站建置",
  },

  learnMore: {
    title: "文件資源",
    sidebarTitle: "文件中心",
    subtitle: "深入了解我們的產品和解決方案",
    sections: {
      introduction: "關於承羽智慧",
      platform: "Sailflow AI Platform",
      gpuServers: "AI 伺服器",
      cluster: "叢集管理軟體",
      useCases: "應用場景",
      pricing: "價格方案",
      support: "技術支援",
      faq: "常見問題",
    },
    backToHome: "返回首頁",
    contentNotFound: "# 內容載入失敗\n\n無法載入所請求的內容。",
  },

  terms: {
    title: "條款",
    sidebarTitle: "條款與政策",
    subtitle: {
      termsOfUse: "使用條款",
      privacyPolicy: "隱私政策",
      slaService: "SLA 服務",
      personalTerm: "個資蒐集",
    },
  },

  rma: {
    title: "RMA 申請",
    backToHome: "返回首頁",
    application: "RMA 申請表單",
    description: "請完整填寫以下資訊，我們將盡快處理您的 RMA 申請",
    customerName: "客戶名稱",
    purchaseDate: "購買日期",
    purchaseDateFormat: "格式範例：YYYY-MM-DD",
    deliveryAddress: "收貨地址",
    shippingAddress: "送貨地址",
    sameAsDelivery: "同收貨地址",
    mobilePhone: "手機",
    modelName: "型號",
    serialNumber: "序號",
    repairQuantity: "維修數量",
    defectSymptom: "不良狀況",
    defectOptions: [
      "訊號不良",
      "無訊號",
      "無電源反應",
      "壞 Port",
      "燈號異常",
      "無法連線",
      "無法設定",
      "易斷線",
      "易當機",
      "偵測不到網路",
      "偵測不到硬體",
      "電源規格不符",
      "會自動 Reset",
      "外觀不良",
      "其它",
    ],
    accessoryOptions: [
      "AI 工作站",
      "AI 伺服器",
      "主機板",
      "電供",
      "記憶體",
      "CPU",
      "GPU",
    ],
    returnAccessories: "送回配件",
    submitApplication: "提交申請",
    submitting: "提交中...",
    submitSuccess: "申請提交成功！我們將盡快與您聯繫。",
    submitError: "提交失敗，請稍後再試。",
  },

  quickStart: {
    title: "文件中心",
    sidebarTitle: "文件中心",
    subtitle: "快速上手，輕鬆部署您的 AI 環境",
    sections: {
      homepageOverview: "首頁導覽",
      userAccount: "使用者帳號",
      aiApplications: "AI算力應用服務",
      userFeatures: "使用者功能",
    },
    backToHome: "返回首頁",
    contentNotFound: "# 內容載入失敗\n\n無法載入所請求的內容。",
  },

  newsCenter: "新聞中心",
  latestNews: "最新動態",
  companyNews: "公司動態",
  pressReleases: "新聞稿",
  events: "活動資訊",
  cookie: {
    title: 'Cookie 隱私權政策',
    description: '我們使用 Cookie 來改善您的瀏覽體驗、分析網站流量及提供個人化服務。您可以選擇接受或拒絕非必要的 Cookie。詳情請參閱我們的',
    necessary: '必要 Cookie',
    necessaryDesc: '維持網站基本功能運作，無法關閉',
    analytics: '分析 Cookie',
    analyticsDesc: '幫助我們了解訪客如何使用網站',
    marketing: '行銷 Cookie',
    marketingDesc: '用於提供個人化廣告與行銷內容',
    alwaysOn: '永遠開啟',
    acceptAll: '全部接受',
    rejectAll: '全部拒絕',
    customize: '自訂偏好',
    savePreferences: '儲存偏好設定',
  },
};

export default zhTW;
